import axiosInstance from "@/axiosInstance";

const state = () => ({
  developers: [],
  projects: [],
  commData: [],
  clients: [],
  salesProductionLoaded: false,
});

const mutations = {
  SET_DEVELOPERS(state, developers) {
    state.developers = developers;
  },
  SET_PROJECTS(state, projects) {
    state.projects = projects;
  },
  SET_COMM_DATA(state, commData) {
    state.commData = commData;
  },
  SET_CLIENTS(state, clients) {
    state.clients = clients;
  },
  SET_SALES_PRODUCTION_LOADED(state, loaded) {
    state.salesProductionLoaded = loaded;
  },
  CLEAR_SALES_PRODUCTION_DATA(state) {
    state.developers = [];
    state.salesProductionLoaded = false;
  },
};

const actions = {
  async fetchSalesProductiondData({ state, commit }) {
    if (state.salesProductionLoaded) return;

    try {
      const [devRes, proRes, commDataRes, clientRes] = await Promise.all([
        axiosInstance.get("developers/"),
        axiosInstance.get("projects/"),
        axiosInstance.get("project-commissions/"),
        axiosInstance.get("client-profiles/")
      ]);
      commit("SET_DEVELOPERS", devRes.data);
      commit("SET_PROJECTS", proRes.data);
      commit("SET_COMM_DATA", commDataRes.data);
      commit("SET_CLIENTS", clientRes.data);
      commit("SET_SALES_PRODUCTION_LOADED", true);
    } catch (error) {
      console.error("Failed to fetch sales production data:", error);
    }
  },
};

const getters = {
  getDevelopers: (state) => state.developers,
  getProjects: (state) => state.projects,
  getCommData: (state) => state.commData,
  getClients: (state) => state.clients,
  isSalesProductionLoaded: (state) => state.salesProductionLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
